export default __webpack_public_path__ + "media/flags/fj-86131889.svg";